import { createSlice } from '@reduxjs/toolkit';
import {
  CreateReels,
  DeleteReels,
  EditReelsDetail,
  GetAllMajorReels,
  GetAllReels,
  GetSingleReelsDetails,
  SearchForReelsByTitle,
  UploadReelsIcon,
  UploadReelsImage,
} from './reels_services_sync';

export const reelsSlice = createSlice({
  name: 'reels',
  initialState: {
    reels_loader: false,
    allReelsLoader: true,
    reelsDeleteLoader: false,
    reelsEditLoader: false,
    relEditLoader: false,
    message: '',
    completeReels: {},
    completeMajorReels: [],
    reelsDetails: {},
    reelsImageDetails: {},
    reelsIconDetails: {},
    completeReelsSearch: {},
    reels_page: 0,
    reels_limit: 10,
    editReelsId: '',
  },
  reducers: {
    clearState: (state) => {
      state.reels_loader = false;
      state.message = '';
      state.completeReels = {};
      state.completeMajorReels = [];
      state.allReelsLoader = true;
      state.reelsDeleteLoader = false;
      state.reelsEditLoader = false;
      state.relEditLoader = false;
      state.reelsDetails = {};
      state.completeReelsSearch = {};
      state.reelsImageDetails = {};
      state.reelsIconDetails = {};
      state.editReelsId = '';

      return state;
    },

    updateReelsDetails: (state, action) => {
      state.reelsDetails = action.payload;
    },

    updateCompleteReels: (state, action) => {
      state.completeReels = action.payload;
    },
    updateReelsId: (state, { payload }) => {
      state.editReelsId = payload;
    },

    updateReelsImageDetails: (state, { payload }) => {
      state.reelsImageDetails = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(CreateReels.pending, (state) => {
        state.reels_loader = true;
      })
      .addCase(CreateReels.fulfilled, (state, { payload }) => {
        state.reels_loader = false;
        state.message = payload.message;
        state.reelsImageDetails = {};
      })
      .addCase(CreateReels.rejected, (state, { payload }) => {
        state.reels_loader = false;
        state.message = payload.message;
      })
      .addCase(UploadReelsImage.pending, (state) => {
        state.reelsEditLoader = true;
      })
      .addCase(UploadReelsImage.fulfilled, (state, { payload }) => {
        state.reelsEditLoader = false;
        state.profileMessage = payload.message;
        state.reelsImageDetails = payload.data;
      })
      .addCase(UploadReelsImage.rejected, (state, { payload }) => {
        state.reelsEditLoader = false;
        state.profileMessage = payload?.message;
      })
      .addCase(UploadReelsIcon.pending, (state) => {
        state.reelsEditLoader = true;
      })
      .addCase(UploadReelsIcon.fulfilled, (state, { payload }) => {
        state.reelsEditLoader = false;
        state.profileMessage = payload.message;
        state.reelsIconDetails = payload.data;
      })
      .addCase(UploadReelsIcon.rejected, (state, { payload }) => {
        state.reelsEditLoader = false;
        state.profileMessage = payload?.message;
      })
      .addCase(GetAllReels.pending, (state) => {
        state.reels_loader = true;
      })
      .addCase(GetAllReels.fulfilled, (state, { payload }) => {
        state.reels_loader = false;
        state.message = payload.message;
        state.completeReels = payload.data;
        state.reels_page = payload?.data?.page;
      })
      .addCase(GetAllReels.rejected, (state, { payload }) => {
        state.reels_loader = false;
        state.message = payload.message;
      })
      .addCase(GetAllMajorReels.pending, (state) => {
        state.reels_loader = true;
      })
      .addCase(GetAllMajorReels.fulfilled, (state, { payload }) => {
        state.reels_loader = false;
        state.message = payload.message;
        state.completeMajorReels = payload.data;
      })
      .addCase(GetAllMajorReels.rejected, (state, { payload }) => {
        state.reels_loader = false;
        state.message = payload.message;
      })
      .addCase(DeleteReels.pending, (state) => {
        state.reelsDeleteLoader = true;
      })
      .addCase(DeleteReels.fulfilled, (state, { payload }) => {
        const filterData = state.completeReels?.docs?.filter(
          (item) => item._id !== payload?.data?._id
        );

        state.completeReels = {
          ...state.completeReels,
          docs: filterData,
        };

        state.reelsDeleteLoader = false;
        state.message = payload.message;

        state.editReelsId = '';
      })
      .addCase(DeleteReels.rejected, (state, { payload }) => {
        state.reelsDeleteLoader = false;
        state.message = payload.message;
        state.editReelsId = '';
      })
      .addCase(GetSingleReelsDetails.pending, (state) => {
        state.reels_loader = true;
      })
      .addCase(GetSingleReelsDetails.fulfilled, (state, { payload }) => {
        state.reels_loader = false;
        state.message = payload.message;
        state.reelsDetails = payload.data;
      })
      .addCase(GetSingleReelsDetails.rejected, (state, { payload }) => {
        state.reels_loader = false;
        state.message = payload.message;
      })
      .addCase(EditReelsDetail.pending, (state) => {
        state.relEditLoader = true;
      })
      .addCase(EditReelsDetail.fulfilled, (state, { payload }) => {
        state.relEditLoader = false;
        state.message = payload.message;

        state.reelsImageDetails = {};
      })
      .addCase(EditReelsDetail.rejected, (state, { payload }) => {
        state.relEditLoader = false;
        state.message = payload.message;
      })

      .addCase(SearchForReelsByTitle.pending, (state) => {
        state.reels_loader = true;
      })
      .addCase(SearchForReelsByTitle.fulfilled, (state, { payload }) => {
        state.reels_loader = false;
        state.message = payload?.message;

        state.completeReelsSearch = payload?.data;
      })
      .addCase(SearchForReelsByTitle.rejected, (state, { payload }) => {
        state.reels_loader = false;
        state.message = payload?.message;
      });
  },
});

export const {
  updateReelsDetails,
  updateCompleteReels,
  updateReelsId,
  updateReelsImageDetails,
} = reelsSlice.actions;
export const reelsSelector = (state) => state.reels;

export default reelsSlice.reducer;
